
import ForumPostDetail from '../../components/ForumPostDetail';

export default function RecommendationsDetailPage() {
  return <ForumPostDetail categoryId="recommendations" />;
}
